export default "__VITE_ASSET__D7t2gzkY__"